import { useState } from "react";
import type { ComponentProps, MouseEvent } from "react";
import { SbtBukejian, SbtFuzhi, SbtYulan } from "@firesoon/icons-react";
import { Typography, Tooltip } from "@mijadesign/web";
import classNames from "classnames";
import { message } from "@mijadesign/web";
import { resolveDesensitizationDisplayValue } from "./utils";

const STYLE_ID = "mijalowcode-desensitization-display-style";
const DESENSITIZATION_DISPLAY_CLASS = "mijalowcode-desensitization-display";
const EYE_ICON_CLASS = "mijalowcode-desensitization-display-eye";

function ensureDesensitizationDisplayStyle() {
  if (typeof document === "undefined") return;
  if (document.getElementById(STYLE_ID)) return;

  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = `
.${DESENSITIZATION_DISPLAY_CLASS} {
  color: inherit;
}

.${DESENSITIZATION_DISPLAY_CLASS} .ant-typography-copy {
  margin-left: 4px;
}

.${EYE_ICON_CLASS} {
  color: #006dfc;
  margin-left: 4px;
}

.${EYE_ICON_CLASS}:hover {
  cursor: pointer;
}
`;
  document.head.appendChild(style);
}

type RuntimeContext = {
  scope?: string;
  area?: string;
  data?: {
    rawValue?: unknown;
    displayValue?: unknown;
    status?: unknown;
    record?: Record<string, unknown>;
    [key: string]: unknown;
  };
};

type DesensitizationDisplayProps = Omit<
  ComponentProps<typeof Typography.Text>,
  "children" | "copyable" | "type"
> & {
  copyableText?: string;
  type?: "idCard" | "phone";
  menuPath?: string;
  runtime?: {
    context?: RuntimeContext;
  };
  __runtimeContext?: RuntimeContext;
};

const DesensitizationDisplay = (props: DesensitizationDisplayProps) => {
  ensureDesensitizationDisplayStyle();

  const {
    copyableText,
    type = "idCard",
    className,
    menuPath,
    runtime,
    __runtimeContext,
    ...rest
  } = props;
  const { Text } = Typography;
  const [showCardNum, setShowCardNum] = useState(false);
  const runtimeContext = runtime?.context || __runtimeContext;

  const { hasValue, value: resolvedValue } =
    resolveDesensitizationDisplayValue(copyableText, runtimeContext);

  if (!hasValue) {
    return "-";
  }
  return (
    <Text
      copyable={{
        text: resolvedValue,
        onCopy: () => {
          message.success("复制成功");
        },
        icon: [
          <SbtFuzhi style={{ color: "#1677FF" }} key={1} />,
          <SbtFuzhi style={{ color: "#1677FF" }} key={2} />,
        ],
      }}
      className={classNames(className, DESENSITIZATION_DISPLAY_CLASS)}
      {...rest}
    >
      {resolvedValue && type === "idCard"
        ? showCardNum
          ? resolvedValue
          : resolvedValue.substring(0, 6) +
            "********" +
            resolvedValue.substring(14, 18)
        : null}
      {resolvedValue && type === "phone"
        ? showCardNum
          ? resolvedValue
          : resolvedValue.substring(0, 3) +
            "****" +
            resolvedValue.substring(7, 11)
        : null}
      {resolvedValue ? (
        showCardNum ? (
          <Tooltip key="tuomin" title="脱敏">
            <SbtYulan
              className={EYE_ICON_CLASS}
              onClick={(e: MouseEvent<SVGSVGElement>) => {
                e.stopPropagation();
                setShowCardNum(!showCardNum);
              }}
            />
          </Tooltip>
        ) : (
          <Tooltip key="chakan" title="查看">
            <SbtBukejian
              className={EYE_ICON_CLASS}
              onClick={(e: MouseEvent<SVGSVGElement>) => {
                e.stopPropagation();
                setShowCardNum(!showCardNum);
              }}
            />
          </Tooltip>
        )
      ) : null}
    </Text>
  );
};
export default DesensitizationDisplay;
export type { RuntimeContext };
